import React from 'react';
import './ProfilePicker.css';
import { PROFILE_INDICES, profileImageUrl } from '../lib/profileImage';

/**
 * Modal grid for choosing a profile image (0~49).
 * Tapping a thumbnail selects it and closes the modal.
 */
export default function ProfilePicker({ current, onSelect, onClose }) {
  return (
    <div className="picker-overlay" onClick={onClose}>
      <div
        className="picker-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="프로필 이미지 선택"
      >
        <div className="picker-header">
          <span className="picker-title">프로필 이미지 선택</span>
          <button
            type="button"
            className="picker-close"
            onClick={onClose}
            aria-label="닫기"
          >
            ✕
          </button>
        </div>

        <div className="picker-grid">
          {PROFILE_INDICES.map((i) => (
            // The cell div carries the square aspect-ratio via the
            // padding-bottom trick. We do NOT put aspect-ratio on the
            // <button> directly — iOS Safari has long-standing bugs where
            // `aspect-ratio` + `overflow:hidden` on a <button> collapses
            // the rendered height, so the cats end up squashed and visually
            // overlap their neighbors. With the div wrapper the height is
            // always exactly == width, in every browser.
            <div className="picker-cell" key={i}>
              <button
                type="button"
                className={`picker-item ${i === current ? 'selected' : ''}`}
                onClick={() => { onSelect(i); onClose(); }}
                aria-label={`프로필 ${i}`}
                aria-pressed={i === current}
              >
                <img src={profileImageUrl(i)} alt={`프로필 ${i}`} draggable={false} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
